import styled from "styled-components/macro";

export const TypographyTitleLargeElement = styled.h3`
  margin: 0;
  font-weight: 400;
`;
